<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="企业品牌" prop="tenantFirmId">
        <a-select
          show-search
          v-model="form.tenantFirmId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in evaluationOptions" :key="d.value">{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="产品编号" prop="productCode">
        <a-input v-model="form.productCode" :disabled="form.id ? true : false" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="产品名称" prop="productName">
        <a-input v-model="form.productName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="可选单位" prop="optionalUnit">
        <div>
          <!-- <template v-for="(tag, index) in tags">
            <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
              <a-tag :key="tag" :closable="true" @close="() => handleClose(index)">
                {{ `${tag.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag v-else :key="tag" :closable="true" @close="() => handleClose(index)">
              {{ tag }}
            </a-tag>
          </template> -->
          <!-- <a-input
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
          />
          <a-tag v-else style="background: #fff; borderstyle: dashed" @click="showInput">
            <a-icon type="plus" /> 单位
          </a-tag> -->
          <a-input v-model="form.optionalUnit" placeholder="请输入"></a-input>
        </div>
      </a-form-model-item>
      <a-form-model-item label="可选规格" prop="productCode">
        <div>
          <!-- <template v-for="(tag, index) in tagslist">
            <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
              <a-tag :key="tag" :closable="true" @close="() => handleCloses(index)">
                {{ `${tag.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag v-else :key="tag" :closable="true" @close="() => handleCloses(index)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input
            v-if="inputVisibles"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            v-model="inputValues"
            @change="handleInputChanges"
            @blur="handleInputConfirms"
            @keyup.enter="handleInputConfirms"
          />
          <a-tag v-else style="background: #fff; borderstyle: dashed" @click="showInputs">
            <a-icon type="plus" /> 口径
          </a-tag>
          <a-input v-model="form.productCode" v-show="isShow"></a-input> -->
          <a-button type="primary" size="small" @click="handleModelAdd" v-if="form.modelCaliberAddParams.length == 0">
            添加
          </a-button>
          <div v-for="(item, index) in form.modelCaliberAddParams" :key="index" class="model_t">
            <a-input v-model="item.name" placeholder="请输入规格"></a-input>
            <a-input v-model="item.sort" placeholder="请输入排序" oninput="value=value.replace(/[^\d]/g,'')"></a-input>
            <a-button
              type="primary"
              size="small "
              style="margin-right: 10px"
              @click="handleModelAdd"
              v-if="index === form.modelCaliberAddParams.length - 1"
            >
              添加
            </a-button>
            <a-button type="danger" size="small " @click="handleModelDel(index)"> 删除 </a-button>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/mode'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    const reg = /^[A-Za-z0-9]+$/
    const validateYa = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入产品编号'))
      } else if (!reg.test(value)) {
        callback(new Error('只能输入数字或英文'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        productName: undefined,
        productCode: undefined,
        optionalUnit: undefined,
        sort: 99,
        modelCaliberAddParams: [],
      },
      isShow: false,
      tags: [],
      tagslist: [],
      showLoading: false,
      evaluationOptions: [
        { value: 1, label: '商品评价' },
        { value: 2, label: '店家服务态度' },
        { value: 3, label: '安装评价' },
        { value: 4, label: '验收评价' },
        { value: 5, label: '服务评价' },
        { value: 6, label: '回访评价' },
        { value: 7, label: '服务人员形象评价' },
        { value: 8, label: '对服务流程讲解' },
        { value: 9, label: '管路检查及丝堵检查' },
        { value: 10, label: '管道真伪查询' },
        { value: 11, label: '打压试验' },
        { value: 12, label: ' 检查管路漏水、虚焊、漏焊' },
        { value: 13, label: ' 是否张贴关闭总阀及温馨提示' },
        { value: 14, label: '拍摄全景管路图' },
      ],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        productName: [{ required: true, message: '请输入的型号名称', trigger: 'blur' }],
        productCode: [
          { required: true, message: '请输入产品编号', trigger: 'blur' },
          { validator: validateYa, trigger: ['blur', 'change'] },
        ],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        optionalUnit: [{ required: true, message: '请添加单位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    showInputs() {
      this.inputVisibles = true
      this.$nextTick(function () {
        this.$refs.inputs.focus()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 单位
    handleInputChange(e) {
      this.inputValue = e.target.value
    },
    // 口径
    handleInputChanges(e) {
      this.inputValues = e.target.value
      console.log(this.inputValues, 'e.target.value')
    },
    // 单位
    handleInputConfirm() {
      const inputValue = this.inputValue
      let tags = this.tags
      if (tags.indexOf(inputValue) !== -1) return this.$message.error('已经有此数据')
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
        console.log(121212)
        this.tags = tags
        this.form.optionalUnit = this.tags.toString()
        this.$refs.form.clearValidate('optionalUnit')
      } else {
        console.log(1212124444)
      }
      // console.log(tags)
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      })
    },
    // 口径
    handleInputConfirms() {
      const inputValue = this.inputValues
      console.log(this.inputValues, 'inputValueinputValue')
      if (this.tagslist.indexOf(inputValue) !== -1) return this.$message.error('已经有此数据')
      if (inputValue && this.tagslist.indexOf(inputValue) === -1) {
        // tags = [...tags, inputValue]
        // console.log(121212)
        // this.tagslist = tags
        // this.inputVisibles = false
        this.tagslist.push(inputValue)
        this.form.productCode = this.tagslist.toString()
        this.$refs.form.clearValidate('productCode')
      }
      this.inputVisibles = false
      this.inputValues = ''
      // console.log(tags, this.tags, this.inputValues, '12121212yyyy')
      // Object.assign(this, {
      //   tags,
      //   inputVisibles: false,
      //   inputValues: '',
      // })
    },
    handleCloses(index) {
      // const tags = this.tags.filter((tag) => tag !== removedTag)
      // console.log(tags)
      this.tagslist.splice(index, 1)
      this.form.productCode = this.tagslist.toString()
    },
    handleClose(index) {
      // const tags = this.tags.filter((tag) => tag !== removedTag)
      // console.log(tags)
      this.tags.splice(index, 1)
      this.form.optionalUnit = this.tags.toString()
    },

    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        productName: undefined,
        productCode: undefined,
        optionalUnit: undefined,
        sort: 99,
        modelCaliberAddParams: [],
      }
      this.tags = []
      this.tagslist = []
    },
    // 点击提交型号口径
    handleModelAdd() {
      if (this.form.modelCaliberAddParams.length === 0) {
        this.form.modelCaliberAddParams.push({ name: '', sort: 1 })
      } else {
        const sort = this.form.modelCaliberAddParams.length + 1
        const index = this.form.modelCaliberAddParams.length - 1
        if (!this.form.modelCaliberAddParams[index].name) return this.$message.error('请输入口径名称')
        if (!this.form.modelCaliberAddParams[index].sort) return this.$message.error('请输入口径排序')
        this.form.modelCaliberAddParams.push({ name: '', sort: sort })
      }
    },
    handleModelDel(index) {
      this.form.modelCaliberAddParams.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加型号'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        // this.tagslist = response.data.productCode.split(',')
        this.tags = response.data.optionalUnit.split(',')
        response.data.modelCaliberAddParams = response.data.modelCalibers
        this.form = response.data
        this.open = true
        this.formTitle = '修改型号'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
